export function errorRequestInterceptor(error: any) {
  console.error({ error })
  return Promise.reject(error)
}
